// GENERATED by apps/platform/scripts/generate-sub-source-options.mjs — do not edit by hand.
// From the platform's committed snapshots: tradeShows.generated.ts (sha 9384031d81524659) and
// articlesManifest.generated.ts (sha 889407eb08237e79). Re-run when either snapshot changes.
/* eslint-disable */

export interface TradeShowSubSourceOption {
  /** events.csv's `id`. */
  id: string
  label: string
  city: string | null
  start_date: string | null
}

export interface ArticleSubSourceOption {
  /** `section/slug`. */
  id: string
  label: string
  section: string
  status: string
}

export const TRADE_SHOW_SUB_SOURCES: readonly TradeShowSubSourceOption[] = [
  {
    "id": "ev001",
    "label": "Archive Resale Summit · Oct 2026",
    "city": "New York",
    "start_date": "2026-10-07"
  },
  {
    "id": "ev002",
    "label": "New York Comic Con · Oct 2026",
    "city": "New York",
    "start_date": "2026-10-08"
  },
  {
    "id": "ev003",
    "label": "Collect-A-Con tour · Oct 2026",
    "city": "Rosemont, IL, USA",
    "start_date": "2026-10-10"
  },
  {
    "id": "ev004",
    "label": "Bar Convent Berlin · Oct 2026",
    "city": "Berlin",
    "start_date": "2026-10-12"
  },
  {
    "id": "ev005",
    "label": "Textile Exchange Conference · Oct 2026",
    "city": "Vancouver",
    "start_date": "2026-10-12"
  },
  {
    "id": "ev006",
    "label": "Frieze London + Masters · Oct 2026",
    "city": "London",
    "start_date": "2026-10-14"
  },
  {
    "id": "ev007",
    "label": "WatchTime New York · Oct 2026",
    "city": "New York",
    "start_date": "2026-10-16"
  },
  {
    "id": "ev008",
    "label": "Windup Watch Fair NYC · Oct 2026",
    "city": "New York",
    "start_date": "2026-10-16"
  },
  {
    "id": "ev009",
    "label": "Sneaker Con · Oct 2026",
    "city": "Anaheim",
    "start_date": "2026-10-17"
  },
  {
    "id": "ev010",
    "label": "The Munich Show · Oct 2026",
    "city": "Munich",
    "start_date": "2026-10-22"
  },
  {
    "id": "ev011",
    "label": "Art Basel Paris · Oct 2026",
    "city": "Paris",
    "start_date": "2026-10-23"
  },
  {
    "id": "ev012",
    "label": "Collect-A-Con tour · Oct 2026",
    "city": "Dallas, TX, USA",
    "start_date": "2026-10-24"
  },
  {
    "id": "ev013",
    "label": "Philly Non-Sports Card Show · Oct 2026",
    "city": "Oaks, PA",
    "start_date": "2026-10-24"
  },
  {
    "id": "ev014",
    "label": "World DPP Compliance Summit · Oct 2026",
    "city": "Berlin",
    "start_date": "2026-10-29"
  },
  {
    "id": "ev015",
    "label": "AES Show Nashville · Oct 2026",
    "city": "Nashville",
    "start_date": "2026-10-30"
  },
  {
    "id": "ev016",
    "label": "Dallas Card Show · Nov 2026",
    "city": "Allen, TX",
    "start_date": "2026-11-05"
  },
  {
    "id": "ev017",
    "label": "Sport Card & Memorabilia Expo · Nov 2026",
    "city": "Mississauga, CA",
    "start_date": "2026-11-05"
  },
  {
    "id": "ev018",
    "label": "Geneva watch auction week · Nov 2026",
    "city": "Geneva",
    "start_date": "2026-11-06"
  },
  {
    "id": "ev019",
    "label": "Collect-A-Con tour · Nov 2026",
    "city": "Houston, TX, USA",
    "start_date": "2026-11-07"
  },
  {
    "id": "ev020",
    "label": "Luxury Law Summit · Nov 2026",
    "city": "New York",
    "start_date": "2026-11-10"
  },
  {
    "id": "ev021",
    "label": "Paris Photo · Nov 2026",
    "city": "Paris",
    "start_date": "2026-11-12"
  },
  {
    "id": "ev022",
    "label": "DesignerCon · Nov 2026",
    "city": "Las Vegas (moved from Anaheim)",
    "start_date": "2026-11-13"
  },
  {
    "id": "ev023",
    "label": "Mega Record & CD Fair · Nov 2026",
    "city": "Den Bosch, NL",
    "start_date": "2026-11-14"
  },
  {
    "id": "ev024",
    "label": "W.O.I. Watches of Italy · Nov 2026",
    "city": "Milan",
    "start_date": "2026-11-14"
  },
  {
    "id": "ev025",
    "label": "Hospices de Beaune · Nov 2026",
    "city": "Beaune",
    "start_date": "2026-11-15"
  },
  {
    "id": "ev026",
    "label": "Antwerp Diamond Days · Nov 2026",
    "city": "Antwerp",
    "start_date": "2026-11-20"
  },
  {
    "id": "ev027",
    "label": "Chicago Sports Spectacular · Nov 2026",
    "city": "Rosemont, IL",
    "start_date": "2026-11-20"
  },
  {
    "id": "ev028",
    "label": "Collect-A-Con tour · Nov 2026",
    "city": "Edison, NJ, USA",
    "start_date": "2026-11-21"
  },
  {
    "id": "ev029",
    "label": "Record Store Day Black Friday · Nov 2026",
    "city": "worldwide (indie stores)",
    "start_date": "2026-11-27"
  },
  {
    "id": "ev030",
    "label": "BoF VOICES · Dec 2026",
    "city": "Oxfordshire, UK",
    "start_date": "2026-12-01"
  },
  {
    "id": "ev031",
    "label": "Untitled Art · Dec 2026",
    "city": "Miami Beach",
    "start_date": "2026-12-02"
  },
  {
    "id": "ev032",
    "label": "Art Basel Miami Beach · Dec 2026",
    "city": "Miami Beach",
    "start_date": "2026-12-04"
  },
  {
    "id": "ev033",
    "label": "Collect-A-Con tour · Dec 2026",
    "city": "Los Angeles, CA, USA",
    "start_date": "2026-12-19"
  },
  {
    "id": "ev034",
    "label": "NADA Miami · Dec 2026",
    "city": "Miami",
    "start_date": "2026-12-20"
  },
  {
    "id": "ev035",
    "label": "CES · Jan 2027",
    "city": "Las Vegas",
    "start_date": "2027-01-06"
  },
  {
    "id": "ev036",
    "label": "NRF Retail's Big Show · Jan 2027",
    "city": "New York",
    "start_date": "2027-01-09"
  },
  {
    "id": "ev037",
    "label": "Pitti Immagine Uomo · Jan 2027",
    "city": "Florence",
    "start_date": "2027-01-12"
  },
  {
    "id": "ev038",
    "label": "Vicenzaoro January · Jan 2027",
    "city": "Vicenza",
    "start_date": "2027-01-15"
  },
  {
    "id": "ev039",
    "label": "Who's Next + Bijorhca · Jan 2027",
    "city": "Paris",
    "start_date": "2027-01-16"
  },
  {
    "id": "ev040",
    "label": "The Winter Show · Jan 2027",
    "city": "New York",
    "start_date": "2027-01-22"
  },
  {
    "id": "ev041",
    "label": "BRAFA · Jan 2027",
    "city": "Brussels",
    "start_date": "2027-01-24"
  },
  {
    "id": "ev042",
    "label": "NAMM Show · Jan 2027",
    "city": "Anaheim",
    "start_date": "2027-01-26"
  },
  {
    "id": "ev043",
    "label": "Première Vision Paris · Jan 2027",
    "city": "Paris",
    "start_date": "2027-01-26"
  },
  {
    "id": "ev044",
    "label": "GJX Tucson · Jan 2027",
    "city": "Tucson",
    "start_date": "2027-01-30"
  },
  {
    "id": "ev045",
    "label": "AGTA GemFair Tucson · Jan 2027",
    "city": "Tucson",
    "start_date": "2027-01-31"
  },
  {
    "id": "ev046",
    "label": "Spielwarenmesse · Feb 2027",
    "city": "Nuremberg",
    "start_date": "2027-02-02"
  },
  {
    "id": "ev047",
    "label": "MIDO · Feb 2027",
    "city": "Milan",
    "start_date": "2027-02-06"
  },
  {
    "id": "ev048",
    "label": "Wine Paris and Vinexpo · Feb 2027",
    "city": "Paris",
    "start_date": "2027-02-15"
  },
  {
    "id": "ev049",
    "label": "MAGIC and PROJECT · Feb 2027",
    "city": "Las Vegas",
    "start_date": "2027-02-16"
  },
  {
    "id": "ev050",
    "label": "Inhorgenta Munich · Feb 2027",
    "city": "Munich",
    "start_date": "2027-02-19"
  },
  {
    "id": "ev051",
    "label": "Coterie · Feb 2027",
    "city": "New York",
    "start_date": "2027-02-20"
  },
  {
    "id": "ev052",
    "label": "Toy Fair New York · Feb 2027",
    "city": "New York",
    "start_date": "2027-02-20"
  },
  {
    "id": "ev053",
    "label": "MICAM Milano · Feb 2027",
    "city": "Milan",
    "start_date": "2027-02-21"
  },
  {
    "id": "ev054",
    "label": "eTail Palm Springs · Feb 2027",
    "city": "Palm Desert, CA",
    "start_date": "2027-02-22"
  },
  {
    "id": "ev055",
    "label": "Lineapelle · Feb 2027",
    "city": "Milan",
    "start_date": "2027-02-23"
  },
  {
    "id": "ev056",
    "label": "Esxence · Feb 2027",
    "city": "Milan",
    "start_date": "2027-02-24"
  },
  {
    "id": "ev057",
    "label": "Frieze Los Angeles · Feb 2027",
    "city": "Santa Monica",
    "start_date": "2027-02-25"
  },
  {
    "id": "ev058",
    "label": "Première Classe · Mar 2027",
    "city": "Paris",
    "start_date": "2027-03-05"
  },
  {
    "id": "ev059",
    "label": "ProWein · Mar 2027",
    "city": "Düsseldorf",
    "start_date": "2027-03-07"
  },
  {
    "id": "ev060",
    "label": "Vision Expo · Mar 2027",
    "city": "Las Vegas",
    "start_date": "2027-03-10"
  },
  {
    "id": "ev061",
    "label": "TEFAF Maastricht · Mar 2027",
    "city": "Maastricht",
    "start_date": "2027-03-13"
  },
  {
    "id": "ev062",
    "label": "A-CAPP Brand Protection Summit · Mar 2027",
    "city": "Dearborn, MI",
    "start_date": "2027-03-16"
  },
  {
    "id": "ev063",
    "label": "LogiMAT · Mar 2027",
    "city": "Stuttgart",
    "start_date": "2027-03-16"
  },
  {
    "id": "ev064",
    "label": "Cosmoprof Bologna · Mar 2027",
    "city": "Bologna",
    "start_date": "2027-03-18"
  },
  {
    "id": "ev065",
    "label": "Shoptalk Spring · Mar 2027",
    "city": "Las Vegas",
    "start_date": "2027-03-22"
  },
  {
    "id": "ev066",
    "label": "Art Basel Hong Kong · Mar 2027",
    "city": "Hong Kong",
    "start_date": "2027-03-25"
  },
  {
    "id": "ev067",
    "label": "Brand Protection Congress Asia · Apr 2027",
    "city": "Bangkok, Thailand (per organizer page; conflict)",
    "start_date": "2027-04-01"
  },
  {
    "id": "ev068",
    "label": "Watches & Wonders · Apr 2027",
    "city": "Geneva",
    "start_date": "2027-04-05"
  },
  {
    "id": "ev069",
    "label": "Vinitaly · Apr 2027",
    "city": "Verona",
    "start_date": "2027-04-11"
  },
  {
    "id": "ev070",
    "label": "IACC Annual Conference · May 2027",
    "city": "Oceanside, CA",
    "start_date": "2027-05-04"
  },
  {
    "id": "ev071",
    "label": "INTA Annual Meeting · May 2027",
    "city": "San Diego",
    "start_date": "2027-05-08"
  },
  {
    "id": "ev072",
    "label": "RFID Journal LIVE! · May 2027",
    "city": "Las Vegas",
    "start_date": "2027-05-20"
  },
  {
    "id": "ev073",
    "label": "GS1 Connect · May 2027",
    "city": "Denver",
    "start_date": "2027-05-24"
  },
  {
    "id": "ev074",
    "label": "Global Fashion Summit · May 2027",
    "city": "Copenhagen",
    "start_date": "2027-05-25"
  },
  {
    "id": "ev075",
    "label": "Licensing Expo · May 2027",
    "city": "Las Vegas",
    "start_date": "2027-05-25"
  },
  {
    "id": "ev076",
    "label": "Couture Las Vegas · Jun 2027",
    "city": "Las Vegas",
    "start_date": "2027-06-02"
  },
  {
    "id": "ev077",
    "label": "JCK Las Vegas · Jun 2027",
    "city": "Las Vegas",
    "start_date": "2027-06-04"
  },
  {
    "id": "ev078",
    "label": "Fanatics Fest · Jul 2027",
    "city": "New York",
    "start_date": "2027-07-20"
  },
  {
    "id": "ev079",
    "label": "San Diego Comic-Con · Jul 2027",
    "city": "San Diego",
    "start_date": "2027-07-22"
  },
  {
    "id": "ev080",
    "label": "National Sports Collectors Convention · Jul 2027",
    "city": "Rosemont, IL",
    "start_date": "2027-07-28"
  },
  {
    "id": "ev081",
    "label": "Pokemon World Championships · Aug 2027",
    "city": "Singapore",
    "start_date": "2027-08-13"
  },
  {
    "id": "ev082",
    "label": "Geneva Watch Days · Sep 2027",
    "city": "Geneva",
    "start_date": "2027-09-20"
  },
  {
    "id": "ev083",
    "label": "Hong Kong Jewellery & Gem Fair · Sep 2027",
    "city": "Hong Kong",
    "start_date": "2027-09-20"
  },
  {
    "id": "ev084",
    "label": "Silmo · Sep 2027",
    "city": "Paris",
    "start_date": "2027-09-20"
  },
  {
    "id": "ev085",
    "label": "Real Circularity LIVE · Sep 2027",
    "city": "London",
    "start_date": "2027-09-22"
  },
  {
    "id": "ev086",
    "label": "Dubai Watch Week · Nov 2027",
    "city": "Dubai",
    "start_date": "2027-11-20"
  },
  {
    "id": "ev087",
    "label": "Altagamma Observatory",
    "city": "Milan",
    "start_date": null
  },
  {
    "id": "ev088",
    "label": "ComplexCon",
    "city": "Los Angeles or Las Vegas (sources conflict); 2026 edition Oct 3-4 already past",
    "start_date": null
  },
  {
    "id": "ev089",
    "label": "FT Business of Luxury Summit",
    "city": "rotating",
    "start_date": null
  },
  {
    "id": "ev090",
    "label": "Making Vinyl",
    "city": "Alexandria VA / Haarlem NL",
    "start_date": null
  },
  {
    "id": "ev091",
    "label": "UK Anti-Counterfeiting Group conference",
    "city": "London",
    "start_date": null
  },
  {
    "id": "ev092",
    "label": "Whisky Live Paris",
    "city": "Paris",
    "start_date": null
  }
]

export const ARTICLE_SUB_SOURCES: readonly ArticleSubSourceOption[] = [
  {
    "id": "insights/resale-royalties-for-brands",
    "label": "Secondary Market Revenue: Can Brands Earn From Resale?",
    "section": "insights",
    "status": "staged"
  },
  {
    "id": "insights/digital-certificates-vs-nfts",
    "label": "Digital Certificates vs NFTs: Why a Product Doesn't Need a Blockchain",
    "section": "insights",
    "status": "staged"
  },
  {
    "id": "insights/what-if-your-designer-bag-could-tell-its-story",
    "label": "What If Your Designer Bag Could Tell You Its Story",
    "section": "insights",
    "status": "staged"
  },
  {
    "id": "insights/fashion-meets-ai-unlocking-consumer-insights-with-connected-garments",
    "label": "Fashion Meets AI: Unlocking Consumer Insights with Connected Garments",
    "section": "insights",
    "status": "staged"
  },
  {
    "id": "insights/verifying-memorabilia-in-the-age-of-digital-fakes",
    "label": "Verifying Memorabilia in the Age of Digital Fakes",
    "section": "insights",
    "status": "staged"
  },
  {
    "id": "insights/recommerce-risks-navigating-the-challenges-of-the-secondhand-market",
    "label": "Recommerce Risks: Navigating the Challenges of the Secondhand Market",
    "section": "insights",
    "status": "staged"
  },
  {
    "id": "insights/the-eus-ecodesign-regulation-implications-for-luxury-brands",
    "label": "The EU's Ecodesign Regulation: Implications for Luxury Brands",
    "section": "insights",
    "status": "staged"
  },
  {
    "id": "learn/product-identity",
    "label": "What is product identity? (for physical products)",
    "section": "learn",
    "status": "staged"
  }
]
